import { useState } from 'react';
import Geolocation from '@helpers/geolocation/geolocation';
import useAvailableStores from '@hooks/useAvailableStores';
import { type SuggestionType } from '@molecules/PickupLocationListItem/PickupLocationListItem';
import { trackDisabledLocationServices, trackFindClosestStore } from '@helpers/analyticsHelpers/trackStoreFinder';

const useFindNearestStore = () => {
  const { allStores } = useAvailableStores();
  const [isFindingNearest, setIsFindingNearest] = useState(false);
  const [showGeolocationErrorModal, setShowGeolocationErrorModal] = useState(false);

  const findNearestStore = (onFound: (store: SuggestionType) => void) => {
    const GeoLocation = Geolocation();
    setIsFindingNearest(true);
    trackFindClosestStore();

    if (allStores?.length) {
      GeoLocation.getMyPosition(
        (latitude: number, longitude: number) => {
          const myCurrentLocation = { latitude, longitude };
          let dist = -1;
          let foundStore: SuggestionType | null = null;

          for (const element of allStores) {
            const storeDist = GeoLocation.compareDistance(
              element.geoPoint?.latitude ?? 0,
              element.geoPoint?.longitude ?? 0,
              myCurrentLocation
            );
            if (dist === -1 || dist > storeDist) {
              dist = storeDist;
              // API returns displayName at runtime but AxfoodStoreInfoViewModel type doesn't declare it
              foundStore = element as unknown as SuggestionType;
            }
          }

          if (foundStore) {
            onFound(foundStore);
          }
          setIsFindingNearest(false);
        },
        () => {
          trackDisabledLocationServices();
          setShowGeolocationErrorModal(true);
          setIsFindingNearest(false);
        }
      );
    }
  };

  return {
    allStores,
    isFindingNearest,
    showGeolocationErrorModal,
    setShowGeolocationErrorModal,
    findNearestStore,
  };
};

export default useFindNearestStore;
